export const getPdftronLicenseKey = () =>
  process.env.REACT_APP_PDFTRON_LICENSE_KEY
